// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/tyre/Tyre.css
// module id = 1140
// module chunks = 0